// @flow
import {connect} from 'react-redux';
import ProductFiltersContainer from '../components/ProductFilters';

import type {RootState} from '../../index';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
  }),
  null
)(ProductFiltersContainer);
